/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import campfire_config_json from "./campfire/config.json";
import { metadata as dailyvideo__metadata_ts } from "./dailyvideo/_metadata";
import { metadata as googlevideo__metadata_ts } from "./googlevideo/_metadata";
import { metadata as huddle01video__metadata_ts } from "./huddle01video/_metadata";
import office365video_config_json from "./office365video/config.json";
import { metadata as zoomvideo__metadata_ts } from "./zoomvideo/_metadata";
export const appStoreMetadata = {
	campfire: campfire_config_json,
	dailyvideo: dailyvideo__metadata_ts,
	googlevideo: googlevideo__metadata_ts,
	huddle01video: huddle01video__metadata_ts,
	office365video: office365video_config_json,
	zoomvideo: zoomvideo__metadata_ts,
};
